"use client";

import { authClient } from "@repo/auth/client";
import { config } from "@repo/config";
import { safeRedirectPath } from "@saas/personas/lib/claim-stash";
import { Button } from "@ui/components/button";
import { useQueryState } from "nuqs";
import { parseAsString } from "nuqs";
import { oAuthProviders } from "../constants/oauth-providers";

export function SocialSigninButton({
	provider,
	className,
}: {
	provider: keyof typeof oAuthProviders;
	className?: string;
}) {
	const [invitationId] = useQueryState("invitationId", parseAsString);
	const [redirectTo] = useQueryState("redirectTo", parseAsString);
	const providerData = oAuthProviders[provider];

	// An invitation outranks `redirectTo` (as on the email form). Otherwise
	// keep where the visitor was headed, e.g. the free prompt generator's
	// "Track these buyers" claim path, but only an app-relative path.
	const redirectPath = invitationId
		? `/app/organization-invitation/${invitationId}`
		: (safeRedirectPath(redirectTo) ?? config.auth.redirectAfterSignIn);

	const onSignin = () => {
		const callbackURL = new URL(redirectPath, window.location.origin);
		authClient.signIn.social({
			provider,
			callbackURL: callbackURL.toString(),
		});
	};

	return (
		<Button
			onClick={() => onSignin()}
			variant="light"
			type="button"
			className={className}
		>
			{providerData.icon && (
				<i className="mr-2 text-primary">
					<providerData.icon className="size-4" />
				</i>
			)}
			{providerData.name}
		</Button>
	);
}
